
	import { DoctorNote, formatDateTime } from "@/domain/entities/EntityFields";
	import useDoctor from "@/store/DoctorState";
	import useNotification from "@/store/NotificationState";
	import usePatientHelper from "@/store/PatientHelperState";
	import { defineComponent, ref } from "vue";

	export default defineComponent({
		// props: {
		// 	doctorNotes: {
		// 		type: Array as PropType<DoctorNote[]>,
		// 		default: [],
		// 	},
		// },
		setup() {
			const { showSnackbar } = useNotification();
			const { patientSelected } = useDoctor();
			const { insertDoctorNote, listenDoctorNotes, doctorNotes } = usePatientHelper();
			listenDoctorNotes(patientSelected.value!.id)


			// add note
			const submittingNewNote = ref(false);
			const newNote = ref<DoctorNote>({
				createdAt: new Date(),
				message: "",
			});
			async function addNewNote() {
				if (newNote.value.message === "") {
					showSnackbar("No se puede ingresar una nota vacía");
					return;
				}
				submittingNewNote.value = true;
				let createdAt = new Date();
				newNote.value.createdAt = createdAt;
				try {
					await insertDoctorNote(
						newNote.value,
						patientSelected.value!.id);
					newNote.value.message = "";
					showSnackbar("Nota agregada");
				} catch (err) {
					console.error('*** error', err);
					showSnackbar("Ocurrió un error al agregar la nota");
				} finally {
					submittingNewNote.value = false;
				}
			}

			// see note
			const activeNote = ref<number>(-1);

			return {
				newNote,
				addNewNote,
				submittingNewNote,
				formatDateTime,
				activeNote,
				doctorNotes,
			};
		},
	});
